module.exports = __webpack_public_path__ + "img/pengembalian.8b9b67a6.jpg";